import { culture } from '../../utils/intl';

const API_URL_BASE = '/api/watchlist';

const handleFetch = (url, fetchOptions = {}, returnJson = true) => fetch(url, fetchOptions)
	.then((res) => {
		if (res.ok) {
			return returnJson ? res.json() : true;
		}

		throw Error('Something went wrong wile fetching');
	});

const get = async () => {
	// IE11 seems to cache the URL and response hard, adding cache busting to prevent this
	const cb = new Date().getTime();

	const {
		userWatchlistItemViewModels = [],
		showIsinColumn = false,
	} = await handleFetch(`${API_URL_BASE}?cultureName=${culture}&cb=${cb}`);

	return {
		items: userWatchlistItemViewModels,
		showIsinColumn,
	};
};

/* `body` should be JSON */
const add = itemId => handleFetch(`${API_URL_BASE}/${itemId}`, { method: 'POST' }, false);
const updateOrder = body => handleFetch(`${API_URL_BASE}/order`, { method: 'POST', body }, false);
const remove = itemId => handleFetch(`${API_URL_BASE}/${itemId}`, { method: 'DELETE' }, false);

export {
	get,
	add,
	updateOrder,
	remove,
};
